import { render, staticRenderFns } from "./order-information.vue?vue&type=template&id=543f5922"
import script from "./order-information.vue?vue&type=script&lang=js"
export * from "./order-information.vue?vue&type=script&lang=js"
import style0 from "./order-information.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports